<tile
    title="{{ 'keywords_top_25' | translate }}"
    icon="trophy"
    change="{{keywordsTop25ChangePercentage}}"
    [showChange]="showChange"
    val="{{ keywordsTop25 | undefinedNumber }}">
</tile>
